import Input from "components/Input/index";
import SquareCheckBox from "components/SquareCheckBox/index";

const Minio = (
    {
        minioEndpoint,
        setMinioEndpoint,
        minioAccessKey,
        setMinioAccessKey,
        minioSecretKey,
        setMinioSecretkey,
        ssl,
        setSsl,
        setVerified,
        setContinued
    }
) => {
    return (
        <>
            <div className="azure">
                <Input
                    label="Minio Access Key"
                    width="90%"
                    placeholder="<access-key>"
                    value={minioAccessKey}
                    maxLength={2000}
                    star="*"
                    clear={true}
                    autoFocus={true}
                    handleClear={
                        () => { setMinioAccessKey(""); setVerified(false); setContinued(false); }
                    }
                    onChange={
                        (value) => { setMinioAccessKey(value.target.value); setVerified(false); setContinued(false); }
                    }
                />
                <Input
                    label="Minio Secret Key"
                    width="90%"
                    placeholder="<secret-key>"
                    value={minioSecretKey}
                    maxLength={2000}
                    star="*"
                    clear={true}
                    handleClear={
                        () => { setMinioSecretkey(""); setVerified(false); setContinued(false); }
                    }
                    onChange={
                        (value) => { setMinioSecretkey(value.target.value); setVerified(false); setContinued(false); }
                    }
                />
                <Input
                    label="MinIO Endpoint"
                    width="90%"
                    placeholder="DefaultEndpointsProtocol=https;AccountName=storagesample;AccountKey=<account-key>"
                    value={minioEndpoint}
                    maxLength={2000}
                    star="*"
                    clear={true}
                    handleClear={
                        () => { setMinioEndpoint(""); setVerified(false); setContinued(false); }
                    }
                    onChange={
                        (value) => { setMinioEndpoint(value.target.value); setVerified(false); setContinued(false); }
                    }
                />
                <SquareCheckBox
                    labelStyles={{ color: "var(--text-grey-strong)", fontFamily: "Helvetica, sans-serif" }}
                    label={"Enable SSL"}
                    isChecked={ssl}
                    handleCheck={
                        () => { setSsl(!ssl); setVerified(false); setContinued(false); }
                    }
                />
                <a href="https://www.ibm.com/docs/en/watsonx/w-and-w/2.0.0?topic=connectors-minio-connection" target="_blank" rel="noopener noreferrer">
                    <p className="helpAzure">
                        For help?
                    </p>
                </a>
            </div>
        </>
    );
};

export default Minio;